module.exports = __webpack_public_path__ + "static/media/template4.aa25aa0d.svg";